import React from "react"
import uniq from "lodash/uniq"
import { getObject, setObject } from "utils/storage"

export const STORAGE_KEY = "cw.clipboard.01"

export const ClipboardContext = React.createContext({
  words: [],
  toggleWord: () => {},
  insertWords: () => {},
  clearWords: () => {},
})

export const ClipboardContextProvider = ({ children }) => {
  const storedVal = getObject(STORAGE_KEY)
  const [words, setWords] = React.useState(storedVal.words || [])

  React.useEffect(() => setObject(STORAGE_KEY, { words }), [words])

  const toggleWord = React.useCallback(
    word => {
      if (words.includes(word)) {
        return setWords(words.filter(w => w !== word))
      }

      setWords([...words, word])
    },
    [words]
  )

  const insertWords = React.useCallback(
    newWords => {
      setWords(uniq([...words, ...newWords]))
    },
    [words]
  )

  const clearWords = React.useCallback(() => {
    setWords([])
  }, [])

  return (
    <ClipboardContext.Provider value={{ words, toggleWord, insertWords, clearWords }}>
      {children}
    </ClipboardContext.Provider>
  )
}
